<template>
  <h5 class="mb-1 fs-7 text-gray-700 mb-2">Застрахованный</h5>
  <div class="podft-list p-4 rounded border mb-3" v-for="(item, index) in displayList" :key="index">
    <div class="podft-list__item" v-if="item.entrepreneur">
      <div class="text-gray-600 fs-7"> Наименование ИП:
        <span class="text-gray-800 float-end">{{ item.entrepreneur }}</span>
      </div>
    </div>
    <div class="podft-list__item">
      <div class="text-gray-600 fs-7"> {{ item.person ? 'ФИО' : '' }}
        <span class="text-gray-800" :class="item.person ? 'float-end' : ''">{{ item.title }}</span>
      </div>
    </div>
    <div class="podft-list__item">
      <div class="text-gray-600 fs-7"> {{ item.person ? 'ИИН' : 'БИН' }}
        <span class="text-gray-800 float-end" :class="item.person ? 'float-end' : ''">{{ item.iin }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PolicyInsured',
  props: {
    insureds: null
  },
  computed: {
    displayList() {
      return (this.insureds ?? []).map(party => this.normalizeParty(party)).filter(Boolean)
    }
  },
  methods: {
    normalizeParty(party) {
      if (!party) return null
      if (!party.client) return party

      const client = party.client
      const filter = party.filter ?? {}
      const title = client.title
        ?? [client.surname, client.name, client.patronymic].filter(Boolean).join(' ').trim()

      return {
        person: filter.person ?? true,
        title: title || null,
        iin: client.iin,
        entrepreneur: party.entrepreneur
      }
    }
  }
}
</script>

<style scoped>

</style>
